const Rebills = () => import(/* webpackChunkName 'Rebills' */ '@/components/Rebills/Rebills.vue');

export default {
    path: 'rebills',
    name: 'Rebills',
    component: Rebills,
    props: true
};